var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C3.14066667,0 0,3.14066667 0,7 C0,10.8593333 3.14066667,14 7,14 C10.8593333,14 14,10.8593333 14,7 C14,3.14066667 10.8593333,0 7,0 Z M8.90166667,9.20266667 L6.22222222,7.41611111 L6.22222222,3.11111111 L7.77777778,3.11111111 L7.77777778,6.58388889 L9.765,7.90844444 L8.90166667,9.20266667 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage);
export default __webpack_public_path__ + "static/media/stage.3c9a73ddd66e4f472e29b7dd42e3a819.svg";
export { ForwardRef as ReactComponent };